// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Kkz5","signatureBlock":"Footer_signatureBlock__mkVsb","signature":"Footer_signature__aJzi-"};